// Put your applicaiton javascript here

$(function () {
  $(".dropdown").hover(
    function () { $(this).addClass('open') },
    function () { $(this).removeClass('open') }
  );
});